export default "__VITE_ASSET__ca3af16c__"